export default {"src":"/_next/static/media/0x657a1861c15a3ded9af0b6799a195a249ebdcbc6.f246cf38.svg","height":75,"width":75,"blurWidth":0,"blurHeight":0};